import { selectIntegrationSettingsSidebarVisibleAndHiddenFieldsForProvider } from 'ducks/integrations'

export default function selectGitHubVisibleFields(state) {
  const {
    visible,
  } = selectIntegrationSettingsSidebarVisibleAndHiddenFieldsForProvider(state, {
    provider: 'github',
  })
  return visible
}
